import React, { useState, useMemo } from 'react';
import { Box, Typography } from '@mui/material';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import { activeTotal } from '../../utils/memberStatus';
import { COLORS, pct, bucketByPeriod } from './signupReportUtils';

const PERIODS = [
  ['daily', 'Daily'],
  ['weekly', 'Weekly'],
  ['monthly', 'Monthly'],
];

const PeriodToggle = ({ value, onChange }) => (
  <Box sx={{ display: 'flex', bgcolor: '#fff', border: '1px solid #EAEAEA', borderRadius: '10px', p: '3px' }}>
    {PERIODS.map(([k, label]) => (
      <Box
        key={k}
        onClick={() => onChange(k)}
        sx={{
          fontSize: 12,
          fontWeight: 600,
          px: 1.5,
          py: 0.7,
          borderRadius: '7px',
          cursor: 'pointer',
          color: value === k ? '#fff' : '#737373',
          bgcolor: value === k ? '#171717' : 'transparent',
        }}
      >
        {label}
      </Box>
    ))}
  </Box>
);

const SignupTrendChart = ({ byDate = [] }) => {
  const [period, setPeriod] = useState('daily');
  const buckets = useMemo(() => bucketByPeriod(byDate, period), [byDate, period]);

  const labels = buckets.map((b) => b.label);
  const signed = buckets.map((b) => b.signed);
  // Active = Approved + Hidden.
  const completion = buckets.map((b) => pct(activeTotal(b), b.signed));

  const options = {
    chart: { height: 320, backgroundColor: 'transparent' },
    title: { text: null },
    credits: { enabled: false },
    xAxis: { categories: labels, labels: { style: { fontSize: '10px', color: '#737373' } } },
    yAxis: [
      { title: { text: 'Signups', style: { fontSize: '10px' } }, gridLineColor: '#F0F0F0', labels: { style: { fontSize: '10px' } } },
      { title: { text: 'Completion %', style: { fontSize: '10px' } }, opposite: true, min: 0, gridLineWidth: 0, labels: { format: '{value}%', style: { fontSize: '10px' } } },
    ],
    legend: { enabled: true, align: 'center', verticalAlign: 'bottom', itemStyle: { fontSize: '11px' } },
    tooltip: { shared: true },
    plotOptions: { column: { borderRadius: 4 } },
    series: [
      { name: 'Signups', type: 'column', data: signed, color: '#E2E8F0', yAxis: 0 },
      {
        name: '% became active',
        type: 'spline',
        data: completion,
        color: COLORS.active,
        lineWidth: 3,
        yAxis: 1,
        marker: { enabled: true, radius: 4 },
        dataLabels: { enabled: true, format: '{y}%', style: { fontSize: '11px', fontWeight: '700', color: COLORS.active, textOutline: 'none' } },
        tooltip: { valueSuffix: '%' },
      },
    ],
  };

  return (
    <Box sx={{ bgcolor: '#fff', border: '1px solid #EAEAEA', borderRadius: '14px', p: 2.2, mb: 2 }}>
      <Box sx={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: 1.5, flexWrap: 'wrap', mb: 2 }}>
        <Box>
          <Typography sx={{ fontSize: 14, fontWeight: 700, color: '#171717' }}>How it&apos;s trending</Typography>
          <Typography sx={{ fontSize: 11.5, color: '#737373' }}>Bars = signups · Green line = % who became active (Approved + Hidden)</Typography>
        </Box>
        <PeriodToggle value={period} onChange={setPeriod} />
      </Box>
      {buckets.length ? (
        <HighchartsReact highcharts={Highcharts} options={options} />
      ) : (
        <Typography sx={{ textAlign: 'center', py: 4, color: '#A3A3A3' }}>No data available</Typography>
      )}
    </Box>
  );
};

export default SignupTrendChart;
